<template>
  <TableLayout :permissions="['business:serverprovider:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="服务商名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入服务商名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="所属行业" prop="industryId">
        <el-select v-model="searchForm.industryId" placeholder="请选择">
          <el-option
            v-for="item in industry"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
<!--        <el-button type="primary" :loading="isWorking.export" v-permissions="['business:serverprovider:exportExcel']" @click="exportExcel">导出</el-button>-->
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:serverprovider:create']">
        <li><el-button type="primary" @click="$refs.operaServerProviderWindow.open('新建服务商信息')" icon="el-icon-plus" v-permissions="['business:serverprovider:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="name" label="服务商名称" min-width="100px"></el-table-column>
        <el-table-column label="LOGO" min-width="120px">
          <template slot-scope="{row}">
            <el-image
              v-if="row.fullLog"
              style="width: 100px; height: 100px"
              :src="row.fullLog"
              :preview-src-list="[row.fullLog]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="industryName" label="所属行业" min-width="100px"></el-table-column>
        <el-table-column label="服务星级" min-width="100px">
          <template slot-scope="{row}">
            {{row.starLevel}}级
          </template>
        </el-table-column>
        <el-table-column prop="linkName" label="联系人姓名" min-width="100px"></el-table-column>
        <el-table-column prop="linkPhone" label="联系人电话" min-width="100px"></el-table-column>
        <el-table-column prop="introduction" label="简介" min-width="100px"></el-table-column>
        <el-table-column label="状态" min-width="100px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              @change="changeStatus($event, row.id)"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          v-if="containPermissions(['business:serverprovider:update', 'business:serverprovider:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaServerProviderWindow.open('编辑服务商信息', row)" icon="el-icon-edit" v-permissions="['business:serverprovider:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:serverprovider:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaServerProviderWindow ref="operaServerProviderWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaServerProviderWindow from '@/components/business/OperaServerProviderWindow'
import { list } from '@/api/business/labels'
import { updateStatus } from '@/api/business/serverProvider'
export default {
  name: 'ServerProvider',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaServerProviderWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        industryId: ''
      },
      industry: []
    }
  },
  created () {
    this.config({
      module: '服务商信息',
      api: '/business/serverProvider',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
    this.getAll()
  },
  methods: {
    async getAll() {
      this.industry = await list({ type: 1, isdeleted: 0 })
    },
    changeStatus(status, id) {
      updateStatus({ id, status })
        .then(res => {
          this.search()
        })
    }
  }
}
</script>
